import { pick as _pick } from "lodash-es";

import { connectRouter } from "connected-react-router";
import { combineReducers } from "redux";

import debugLog from "./debugLog";
import events from "./events";
import humans from "./humans";
import humanComments from "./humanComments";
import humansFilterQuery from "./humansFilterQuery";
import humansSortOrder from "./humansSortOrder";
import loading from "./loading";
import user from "./user";
import circles from "./circles";
import deletedObjects from "./deletedObjects";
import humanContacts from "./humanContacts";
import { LOGOUT_USER_SUCCESS, CLEAR_CACHE } from "../actions/user";

export default function createRootReducer(history, debug) {
  const appReducer = combineReducers({
    router: connectRouter(history),
    user,
    humans,
    humanComments,
    humansFilterQuery,
    humansSortOrder,
    events,
    loading,
    circles,
    deletedObjects,
    humanContacts,
    ...(debug ? { debugLog } : undefined),
  });

  const rootReducer = (state, action) => {
    switch (action.type) {
      case LOGOUT_USER_SUCCESS: {
        state = _pick(state, ["router", "debugLog"]);
        break;
      }
      case CLEAR_CACHE: {
        state = _pick(state, ["router", "debugLog", "user"]);
        break;
      }
      default: {
        break;
      }
    }

    return appReducer(state, action);
  };

  return rootReducer;
}
